import classNames from 'classnames/dedupe';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Color, Variant } from 'react-bootstrap/types';

export interface PageCardProps {
  id?: string;
  bg?: Variant;
  text?: Color;
  border?: Variant;
  title?: string | JSX.Element;
  additionalinfo?: string | JSX.Element;
  actionElement?: React.ReactElement;
  titleClassName?: string;
  bodyClassName?: string;
  actionSectionClassName?: string;
  className?: string;
  topBanner?: JSX.Element | undefined;
}

export const PageCard = (props: React.PropsWithChildren<PageCardProps>) => {
  const {
    title,
    additionalinfo,
    children,
    actionElement,
    className,
    bodyClassName: _bodyClassName,
    titleClassName,
    actionSectionClassName,
    topBanner,
    ...trimmedProps
  } = props;
  //all the properties are passed to the card, including children, the card renders the children.
  //1/10/2022 - turned off body on Card, manually render body to control padding/margin.  Set margin/padding on title and content instead, added properties to override body/title margin classes and body/title classes.
  return (
    <Card
      body={false}
      className={classNames('card', 'page-card', className)}
      {...trimmedProps}
    >
      <div className={classNames('card-body')}>
        {(title || actionElement) && (
          <div className={classNames('card-title', titleClassName)}>
            {topBanner && topBanner}
            <div
              className={classNames(
                'd-flex flex-fill justify-content-between align-items-top',
                actionSectionClassName,
              )}
            >
              <div>
                {typeof title === 'string' ? (
                  <h2 className={classNames('pagecard-header')}>{title}</h2>
                ) : (
                  title
                )}
              </div>
              {additionalinfo}
              {actionElement && <div>{actionElement}</div>}
            </div>
          </div>
        )}
        {children}
      </div>
    </Card>
  );
};

PageCard.defaultProps = {
  border: '0',
  bg: 'white',
  text: 'black',
};

export default PageCard;
